import SupportService from '@/common/api/support'

const actions = {
  getSupportBoxList (context, data) {
    return new Promise((resolve, reject) => {
      SupportService.getList(data)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  getSupportBoxDetail (context, id) {
    return new Promise((resolve, reject) => {
      SupportService.getDetail(id)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },
  replySupport (context, data) {
    const formData = new FormData()
    formData.append('support_id', data.support_id)
    formData.append('body', data.body)

    if (data.image) {
      formData.append('image', data.image)
    }
    return new Promise((resolve, reject) => {
      SupportService.reply(formData)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(err => reject(err))
    })
  }
}

export default {
  actions
}
